import React from 'react'

export default function Iso({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className}>
      <path
        fill="currentColor"
        d="M32.3 16c-3.5 0-6.4 2.9-6.4 6.4v21.5c0 3.5 2.9 6.4 6.4 6.4 3.5 0 6.4-2.9 6.4-6.4V22.4c0-3.5-2.9-6.4-6.4-6.4zM62.6 48.8V8.9c0-3.5-2.9-6.4-6.4-6.4s-6.4 2.9-6.4 6.4v39.9c0 3.5 2.9 6.4 6.4 6.4s6.4-2.9 6.4-6.4zM14.8 15.8c0-3.5-2.9-6.4-6.4-6.4S2 12.2 2 15.8v39.9C2 59.1 4.8 62 8.4 62s6.4-2.9 6.4-6.4V15.8z"
      />
    </svg>
  )
}
